import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 8rem;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
`;

export const Msg = styled.span`
  font-family: 'LibreBaskervilleRegular', sans-serif;
  font-size: 1rem;
  color: #000;
  &[dir=rtl] {
    font-family: 'GESSTwoDWTCLight','DINRegular',sans-serif;
  }
`;
